var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{ref:"p",staticClass:"auto-text",class:_vm.disabled ? '' : (_vm.foldFlag ? 'fold' : 'spread'),style:(_vm.styles),attrs:{"title":_vm.disabled ? '' : (_vm.foldFlag ? '点击展开' : '点击收起')},domProps:{"innerHTML":_vm._s(_vm.analysisContent)},on:{"click":_vm.trigger}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-135a12ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/baseComponent/TextAutoContainer.vue
// module id = null
// module chunks = 